import Joi from 'joi';

/**
 * Schema for existing record validation.
 */
export const updateVehicleInsuranceClaimSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
